import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as currentStatusActions from 'modules/currentStatus';

import { Label, Icon } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './MyPageTemplate.css';
const cx = classNames.bind(styles);

class MyPageTemplate extends PureComponent {
  componentDidMount() {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.pageHeight(this.pageRef.clientHeight);
  }

  render() {
    const { children, className } = this.props;
    return (
      <div className={cx('admin-page-box', className)} ref={ref => (this.pageRef = ref)}>
        {children}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(MyPageTemplate);



// WEBPACK FOOTER //
// ./src/script/components/mypage/MyPageTemplate.js